import React from 'react';
import type { Step } from 'react-joyride';

import Mp4GifEmulator from 'components/common/ui/Mp4GifEmulator';

import mp4 from 'assets/videos/guestlist/walkthroughGuestList.mp4';

import styles from '../ManageAddressCollectionLinkTour.module.less';

const Step2Component: React.FC = () => (
  <div>
    <p className={styles.stepCopy}>
      Once guests click your link and fill out a form, their info will appear in your guest list.
      Already have a few addresses? Upload them here, too.
    </p>
    <Mp4GifEmulator src={mp4} className={styles.gif} />
  </div>
);

const Step2: Step = {
  target: '.navSecondary__dropdown--YourGuestList',
  content: <Step2Component />,
  placement: 'bottom',
  disableBeacon: true,
};

export default Step2;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLinkTour/Steps/Step2.tsx